import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

export const DEFAULT_STATE: IFormJBPHPContactChangeRequest = {
  EntryId: -1,
  PartnerId: '',
  Email: '',
  FirstName: '',
  LastName: '',
  BusinessUnit: '',
  Roles: '',
  LeadPBM: 0,
  AssignmentPeriod: '',
  ManagerEmail: '',
  ManagerFirstName: '',
  ManagerLastName: '',

  // Fields from 1217
  TicketId: -1,
  TicketStatus: '',
  RequestAction: '',
  SignId: '',
}
